import axios from "axios";
import axiosInstance from "utils/axiosInstance";
import { PRESIGNED_URL } from "constants/api";

export const getUploadFileType = (file: File) => {
  if (file.type) return file.type;

  const extension = file.name.split(".").pop()?.toLowerCase();
  const fallbackTypes: Record<string, string> = {
    gif: "image/gif",
    heic: "image/heic",
    heif: "image/heif",
    jpeg: "image/jpeg",
    jpg: "image/jpeg",
    png: "image/png",
    webp: "image/webp",
  };

  return fallbackTypes[extension || ""] || "application/octet-stream";
};

export const isAllowedAlertImage = (file: File) => {
  const fileType = getUploadFileType(file);
  return (
    fileType.startsWith("image/") ||
    /\.(gif|heic|heif|jpe?g|png|webp)$/i.test(file.name)
  );
};

export const getStableUploadUrl = (responseData: any, uploadUrl: string) =>
  responseData?.publicUrl ||
  responseData?.fileUrl ||
  responseData?.stableUrl ||
  responseData?.imageUrl ||
  uploadUrl.split("?")[0];

export const uploadDonationWidgetImage = async (
  file: File,
  onProgress?: (progress: number) => void,
) => {
  if (!isAllowedAlertImage(file)) {
    throw new Error("ຮອງຮັບຮູບ PNG, JPG, GIF, WEBP, HEIC ຫຼື HEIF ເທົ່ານັ້ນ");
  }

  const fileType = getUploadFileType(file);
  const responseUrl = await axiosInstance.post(PRESIGNED_URL, {
    name: fileType,
    fileName: file.name,
    fileType,
  });
  const uploadUrl = responseUrl.data?.url;

  if (!uploadUrl) throw new Error("Upload URL not found");

  await axios.put(uploadUrl, file, {
    timeout: 120000,
    headers: {
      "Content-Type": fileType,
    },
    onUploadProgress: (progressEvent) => {
      if (!progressEvent.total) return;
      onProgress?.(
        Math.round((progressEvent.loaded * 100) / progressEvent.total),
      );
    },
  });

  return getStableUploadUrl(responseUrl.data, uploadUrl);
};
